export default {
  keyboardShortcuts: 'Keyboard shortcuts',
  siteWideShortcuts: 'Site-wide shortcuts',
  loading: 'Loading',
  errorTitle: 'Something went wrong',
  errorMessage:
    'Keyboard shortcuts could not be loaded due to an unknown error. If the problem persists, please contact support.',
}
